import * as React from "react";
import * as _ from 'lodash';
import moment from "moment";
import makeStyles from "@mui/styles/makeStyles";
import {
    FormControl,
    FormLabel,
    Grid,
    TextField,
    IconButton, MenuItem, Select, Button,
} from "@mui/material";
import DatePicker from "@mui/lab/DatePicker";
import {useTranslation} from "react-i18next";
import DeleteIcon from '@mui/icons-material/Delete';
import TimePicker from "@mui/lab/TimePicker";
import AddIcon from '@mui/icons-material/Add';
import {setSnackbar} from '../../store/reducers/globals';
import {useDispatch} from 'react-redux';
import {Autocomplete} from '@mui/lab';
import {useEffect, useRef} from 'react';

const useStyles = makeStyles((theme) => ({
    label: {
        color: theme.palette.admissionForm.labelColor,
        lineHeight: "32px",
        fontWeight: "500",
        fontSize: "0.95rem",
    },
    notesInput: {
        backgroundColor: theme.palette.background.paperDarker,
        borderColor: theme.palette.admissionForm.borderColor,
        borderRadius: "6px",
        color: theme.palette.admissionForm.textColor,
        resize: "none",
    },
    removeOption: {
        width: "calc(100% - 52px)",
        display: "inline-flex"
    },
    removeBtn: {
        width: "40px",
        display: "inline-flex",
        height: "40px",
        marginTop: "41px",
        borderRadius: "10px",
        justifyContent: "center",
        backgroundColor: "rgba(255, 255, 255, 0.03)",
        "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.10)",
            cursor: "pointer"
        }
    },
    avrProcInfo: {
        backgroundColor: theme.palette.admissionForm.procedureAvgTimeBackground,
        border: "1px solid",
        borderColor: theme.palette.admissionForm.toggleBackgroundDarker,
        color: theme.palette.admissionForm.procedureAvgTimeText,
        borderRadius: "5px",
        padding: "10px 20px",
        marginTop: "15px",
        display: "box",
        boxPack: "justify",
        boxAlign: "center"
    }
}))

const useStylesProcedureSection =  makeStyles((theme) => ({
    hr: {
        height: "3px",
        marginLeft: "-20px",
        marginRight: "-20px",
        marginTop: "22px",
        marginBottom: "12px",
        backgroundColor: theme.palette.background.default
    }
}))

export const proceduresSchema = {
    procedures: [], //object of procedure
    proceduresLen: [], //number #.#
}

export const procedureEditSchema = {
    procedure: "",
    avgTime: moment().hours(0).minutes(0).year(0).month(0).date(0).seconds(0),
    time: moment().hours(0).minutes(0).year(0).month(0).date(0).seconds(0)
}

export function ProcedureItem(props) {
    const classes = useStyles();
    const {t} = useTranslation();
    const [proceduresDict, setProceduresDict] = React.useState([]);
    const [avgTime, setAvgTime] = React.useState(0);


    const removeItem = () => {
        props.onChange("remove_proc", props.index);
    }

    useEffect(() => {
        if(props.procedureItem) {
            const durationSys = _.find(props.procedureItem?.systype, {"code": props.systype});
            setAvgTime(durationSys?.duration);
        }
    },[props.systype])

    useEffect(()=>{
     //   console.log(props.overseeingConsultant?.procedures, props.proceduresDict.length);
        let proceduresDict = _.filter(props.proceduresDict, (dictItem) => {
            if(_.find(dictItem.systype, {"code": props.systype})){
                 if(!props.overseeingConsultant || !props.overseeingConsultant.procedures || props.overseeingConsultant.procedures?.some((p) => p === dictItem.__id ))
                     return dictItem;
            }
        });

        proceduresDict = _.sortBy(proceduresDict, ['__description'])
        setProceduresDict(proceduresDict);
    }, [props.proceduresDict, props.systype, props.overseeingConsultant]);


    const handleSetProcedure = (proc, reason) => {
        const durationSys = _.find(proc.systype, {"code": props.systype});
        setAvgTime(durationSys.duration);

        props.onChange("update", props.index, proc);
        props.onChange("update_time", props.index, proc, durationSys.duration);
    }


    const handleSetTime = (time) => {
        let minutesValueInt = 0;
        if(time) {
            //  minutesValueInt += time.date() * 1440;
            minutesValueInt += time.hours() * 60;
            minutesValueInt += time.minutes();
        }


        props.onChange("update_time", props.index, props.procedureItem, minutesValueInt);
    }


    const convertMinutesToTime = (minutes) => {
        const duration = minutes;
        let hD = duration % 60;
        let mD = duration - hD*60;
        return moment().startOf("year").hours(hD).minutes(mD)
    }

    return (
        <div style={{display: "flex"}} key={"procedure_item_edit_" + props.index}>
            <Grid container className={props.removable ? classes.removeOption : ""}>
                <Grid item xs={6} sx={{padding: "10px"}}>
                    <FormControl sx={{ width: "100%", marginRight: "10px" }}>
                        {!props.procedureMDU && <FormLabel id={"procedure-select-" + props.index} className={classes.label}>{t("Procedure")}&nbsp;{props.index + 1}</FormLabel>}
                        {props.procedureMDU && <FormLabel id={"procedure-select-" + props.index} className={classes.label}>{t("Main Procedure")}</FormLabel>}
                        <Autocomplete
                            id={"combo-box-dicts-procedure-select-" + props.index}
                            options={proceduresDict}
                            sx={{ m: 0, width: '100%' }}
                            renderInput={(params) => <TextField {...params}  size={"small"} label={t("Select procedure")} />}
                            getOptionLabel={option => (option?.__description? option?.__description: option?.description)+" ("+option.specialty+")"}
                            isOptionEqualToValue={(option, value) => option?.__description === value?.__description}
                            value={props.procedureItem}
                            disabled={props.disabled || props.isBooked}
                            disableClearable
                           // disablePortal
                            onChange={(event, selected, reason) =>
                                //setDictField(selected, reason, itemFieldConfig.id)
                                handleSetProcedure(selected, reason)
                            }
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6} sx={{padding: "10px"}}>
                    <FormControl sx={{ width: "100%", marginRight: "10px" }}>
                        <FormLabel id="procedure-notes-label" className={classes.label}>
                            {props.procedureMDU? t("Approximate Timing"): t("Time (Procedure Duration, incl. Anaesthetic)")} HH:mm
                        </FormLabel>
                        <TimePicker
                            ampm={false}
                            openTo="minutes"
                            views={['hours', 'minutes']}
                            inputFormat="HH:mm"
                            mask="__:__"
                            disabled={props.disabled || props.isBooked}
                            value={convertMinutesToTime(props.procedureLen?.[props.index])}
                            onChange={(newValue) => {
                                console.log( "Time setted", newValue);
                                handleSetTime(newValue);
                            }}
                            renderInput={(params) => <TextField {...params}  size={"small"} />}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6}>&nbsp;</Grid>
                <Grid item xs={6} sx={{padding: "10px"}}>
                    <div className={classes.avrProcInfo}>
                        <div>
                            Avg. Time of Procedure (HH:mm)
                        </div>
                        <div>
                            {convertMinutesToTime(avgTime).format("HH:mm")}
                        </div>
                    </div>
                </Grid>
            </Grid>
            {props.removable &&
                <div className={classes.removeBtn}>
                    <IconButton aria-label="delete" size="large"  disabled={props.disabled || props.isBooked} onClick={removeItem}>
                        <DeleteIcon/>
                    </IconButton>
                </div>
            }
        </div>
    )
}

export function FromProceduresSection(props) {
    const classes = useStylesProcedureSection();
    const {t} = useTranslation();

    const handleAddProcedure = () => {
        props.onChange("add_proc");
    }

    return (
        <React.Fragment>
            {props.procedure && props.procedure.length > 0 && props.procedure.map((proc, index) => {
                return (
                    <React.Fragment>
                        {index > 0 &&
                            <div key={"procedure-space-block-"+index} className={classes.hr}/>
                        }
                        <ProcedureItem key={"procedure-block-"+index} index={index}
                                       procedureItem={proc} removable={true}
                                       {...props}
                        />
                    </React.Fragment>
                )
            })}
            <Button variant="outlined" startIcon={<AddIcon />} sx={{ margin: "12px 5px"}}
                    disabled={props.disabled || props.isBooked}
                    onClick={handleAddProcedure}>
                {t("Add new Procedure")}
            </Button>
        </React.Fragment>
    )
}